import { TabIndicatorState } from '../Tabs/types';
import { hasVeeValidationErrorsForPaths } from './utils';
import { veeFormInjectionKey } from '@/components/forms/useVeeForm';
import { injectStrict } from '@/utils/injectStrict';

export const useFormTab = () => {
  const form = injectStrict(veeFormInjectionKey);

  function getIndicatorState(paths: string[]): TabIndicatorState | undefined {
    return hasVeeValidationErrorsForPaths(form.errors.value, paths)
      ? TabIndicatorState.ERROR
      : undefined;
  }

  /**
   * This function is used in forms with `keepValuesOnUnmount: true` and multiple tabs
   * to make sure, that "old" errors are shown again (next to the VeeForm-components).
   */
  async function handleTabChange() {
    const pathStates = (form as any).getAllPathStates(); // private method of vee-validate
    const updatedStates = Object.fromEntries(
      pathStates?.map((pathState: { path: string }) => [pathState.path, true]) ?? [],
    );
    form.setTouched(updatedStates);
    await form.validate({ mode: 'force' });
  }

  return { getIndicatorState, handleTabChange };
};
